/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementsSearch} from '../models/EntitlementsSearch';
import type {Error} from '../models/Error';
import type {SortDirection} from '../models/SortDirection';

export interface SearchProductEntitlements$Request {
    pageNumber: number;
    pageSize: number;
    sortDirection: SortDirection;
    requestBody?: Array<string>;
}

export interface SearchProductEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchProductEntitlementsRequest = createAction<PayloadData<void, SearchProductEntitlements$Request>>('PRODUCT_ENTITLEMENTS_SEARCH__SEARCH_PRODUCT_ENTITLEMENTS__REQUEST');
export const searchProductEntitlementsSuccess = createAction<PayloadData<EntitlementsSearch, SearchProductEntitlements$Request>>('PRODUCT_ENTITLEMENTS_SEARCH__SEARCH_PRODUCT_ENTITLEMENTS__SUCCESS');
export const searchProductEntitlementsFailure = createAction<PayloadData<Error, SearchProductEntitlements$Request, true>>('PRODUCT_ENTITLEMENTS_SEARCH__SEARCH_PRODUCT_ENTITLEMENTS__FAILURE');

export const searchProductEntitlementsActions = [
    searchProductEntitlementsRequest,
    searchProductEntitlementsSuccess,
    searchProductEntitlementsFailure
] as const;

/**
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {SortDirection} meta.sortDirection
 * @param {Array<string>} [meta.requestBody]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchProductEntitlements = (meta: SearchProductEntitlements$Request, config?: SearchProductEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
        sortDirection: meta.sortDirection,
    };
    return {
        CALL_API: {
            types: searchProductEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/entitlements/search`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

